import { create } from 'zustand';

/** @typedef {import('../graphql/fragments/user.js').User} User */

export const useAuthStore = create((set) => ({
  currentUser: null,
  accessToken: null,
  isLoading: true,
  isImpersonating: false,
  originalUser: null,
  setUser: (user) => set({ currentUser: user }),
  setTokens: (accessToken) => set({ accessToken }),
  setLoading: (isLoading) => set({ isLoading }),
  setImpersonating: (isImpersonating, originalUser = null) =>
    set({ isImpersonating, originalUser }),
  clear: () =>
    set({
      currentUser: null,
      accessToken: null,
      isImpersonating: false,
      originalUser: null,
    }),
}));

export const authStoreInitialState = {
  currentUser: null,
  accessToken: null,
  isLoading: true,
  isImpersonating: false,
  originalUser: null,
};
